// import React, { useEffect, useState, useCallback } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import PersonaNatural from '../../components/PersonaNatural'
// import { Link, useParams, useNavigate, useLocation } from 'react-router-dom';
// import PersonDirection from '../../components/PersonDirection'
// import { Grid, Card, CardContent, Typography, Button, Snackbar, Alert, Box } from '@mui/material';
// import { Save as IconSave } from "@mui/icons-material";
// import PersonDocument from '../../components/PersonDocument'
// import PersonContact from '../../components/PersonContact'
// import PersonBonding from '../../components/PersonBonding'
// import PersonPast from '../../components/PersonPast'
// import { activeValidationsPersonaNatural, setNombreVinculado, setTipoPersona, initPerson } from "../../redux/personSlice";
// import { activeValidationsPersonaDocumento } from "../../redux/personDocumentSlice";
// import { setPersonaDirecciones, defaultPersonaDirecciones } from '../../redux/personDirectionSlice';
// import { setPersonaVinculaciones, defaultPersonaVinculaciones } from '../../redux/personBondingSlice';
// import { setPersonaContactos, defaultPersonaContactos } from '../../redux/personContactSlice';
// import { setPersonaDocumentos, defaultPersonaDocumentos } from '../../redux/personDocumentSlice';
// import { setPersonaAntecedentes, defaultPersonaAntecedentes } from '../../redux/personPastSlice';
// import * as personaService from "../../services/personaService";
// import * as catalogoService from "../../services/catalogoService";
// import { notifySuccess, notifyWarning, notifyError } from "../../services/notificationService";

// const Edit = (props) => {
//   const dispatch = useDispatch();
//   const params = useParams();
//   const navigate = useNavigate();
//   const sliceKey = "personEdit";

//   useEffect(() => {
//       dispatch(initPerson({ sliceKey: sliceKey }));
//   }, [dispatch, sliceKey]);

//   const personaNatural = useSelector((state) => state.person[sliceKey]?.personaNatural);
//   const personaDirecciones = useSelector((state) => state.personDirection[sliceKey]?.personaDirecciones);
//   const personaDocumentos = useSelector((state) => state.personDocument[sliceKey]?.personaDocumentos);
//   const personaContactos = useSelector((state) => state.personContact[sliceKey]?.personaContactos);
//   const personaAntecedentes = useSelector((state) => state.personPast[sliceKey]?.personaAntecedentes);
//   const personaVinculaciones = useSelector((state) => state.personBonding[sliceKey]?.personaVinculaciones);
//   const personaNaturalValidation = useSelector((state) => state.person[sliceKey]?.validationMessage);
//   const personaDocumentosValidation = useSelector((state) => state.personDocument[sliceKey]?.validationMessage);
//   const nombreVinculado = useSelector((state) => state.person[sliceKey]?.nombreVinculado);
//   const tipoPersona = useSelector((state) => state.person[sliceKey]?.tipoPersona);

//   const [enabledSave, setEnabledSave] = useState(true)
//   const [idNew, setIdNew] = useState(0)

//   const fetchNombreVinculado = useCallback(async () => {
//     if (params.idPersona > 0){
//       const response = personaService.getPersonaById(params.idPersona)
//       dispatch(setNombreVinculado(response.nombres))
//     }
//   }, [])
//   const fetchTipoPersona = useCallback(async () => {
//     if (params.idTipoPersona > 0){
//       const response = catalogoService.GetCatalogoById(params.idTipoPersona)
//       dispatch(setTipoPersona(response.descripcion))
//     }
//   }, [])
//   const fetchOpen = useCallback(async () => {
//     setEnabledSave(true)
//   }, [props.openClose])

//   useEffect(() => {
//     fetchNombreVinculado();
//     fetchTipoPersona();
//     fetchOpen();
//   }, [])

//   const personaPost = async () => {
//     var dataPost = {
//       ...personaNatural, nombres: personaNatural.primerApellido + " " + personaNatural.segundoApellido + " " + personaNatural.primerNombre + " " + personaNatural.segundoNombre
//       , idSexo: parseInt(personaNatural.idSexo)
//       , personaDireccion: personaDirecciones, personaDocumento: personaDocumentos, personaContacto: personaContactos, personaVinculacion: personaVinculaciones
//       , personaAntecedente: personaAntecedentes
//     }

//     var ValidationMessages = personaNaturalValidation.concat(personaDocumentosValidation)

//     if (ValidationMessages.length > 0) {
//       dispatch(activeValidationsPersonaNatural({sliceKey: sliceKey}));
//       dispatch(activeValidationsPersonaDocumento({sliceKey: sliceKey}));

//       notifyWarning(ValidationMessages.join(" - "))
//     }
//     else {
//       try {
//         const response = await personaService.postPersonaNaturalUpdateWithDetails(dataPost)

//         notifySuccess("Se guardaron los datos con éxito");
//         setIdNew(parseInt(response.data.data))
//         setEnabledSave(false);

//         if (personaNatural.id > 0) {
//           const directions = await personaService.getsPersonaDireccionView(personaNatural.id)
//           const bondings = await personaService.getsPersonaVinculacionView(personaNatural.id)
//           const contacts = await personaService.getsPersonaContactoView(personaNatural.id)
//           const documents = await personaService.getsPersonaDocumentoView(personaNatural.id)
//           const pasts = await personaService.getsPersonaAntecedenteView(personaNatural.id)
          
//           dispatch(setPersonaDirecciones({sliceKey: sliceKey, data: directions?.length ? directions : defaultPersonaDirecciones}));
//           dispatch(setPersonaVinculaciones({sliceKey: sliceKey, data: bondings?.length ? bondings : defaultPersonaVinculaciones}));
//           dispatch(setPersonaContactos({sliceKey: sliceKey, data: contacts?.length ? contacts : defaultPersonaContactos}));
//           dispatch(setPersonaDocumentos({sliceKey: sliceKey, data: documents?.length ? documents : defaultPersonaDocumentos}));
//           dispatch(setPersonaAntecedentes({sliceKey: sliceKey, data: pasts?.length ? pasts : defaultPersonaAntecedentes}));
//         }
//       } catch (error) {
//         notifyError(error.response?.data?.message ?? error.message ?? "An unexpected error occurred.");
//       }
//     }
//   }

//   return (
//     <div>
//       <Grid container spacing={0}>
//         <Grid item xs={8} sm={8}>
//           <Typography variant="h5" component="span">
//             <Box sx={{ fontWeight: 'bold' }}>
//               {(params.id == 0 ? (params.idTipoPersona > 0 ? "Registrar " + tipoPersona : "Nueva Persona") : "Editar Persona")}
//             </Box>
//           </Typography>
//         </Grid>
//         <Grid item xs={4} sm={4}>
//           <Box textAlign='right'>
//             <Link to={'/person'} >{"Volver"}</Link>
//           </Box>
//         </Grid>
//       </Grid>

//       <Typography gutterBottom component="span">
//         <Box textAlign='center' padding={1}>
//           <Button variant="outlined" size='small' onClick={() => {personaPost()}} disabled={!enabledSave} >
//             {(params.id > 0 ? "Guardar" : idNew > 0 && params.idTipoPersona == 23 ? "Registrar a la Madre" : "Guardar")}
//             <IconSave />
//           </Button>
//         </Box>
//       </Typography>

//       <Grid container spacing={1}>
//         <Grid item xs={12} sm={12}>
//           <Card >
//             <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
//               <PersonaNatural sliceKey={sliceKey} hideInputs={false} id={params.id} autoFocus />
//             </CardContent>
//           </Card>
//         </Grid>
//         <Grid item xs={12} sm={6}>
//           <Card>
//             <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
//               <PersonDocument sliceKey={sliceKey} id={params.id} />
//             </CardContent>
//           </Card>
//         </Grid>
//         <Grid item xs={12} sm={6}>
//           <Card>
//             <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
//               <PersonContact sliceKey={sliceKey} id={params.id} />
//             </CardContent>
//           </Card>
//         </Grid>
//         <Grid item xs={12} sm={12}>
//           <Card>
//             <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
//               <PersonDirection sliceKey={sliceKey} id={params.id} />
//             </CardContent>
//           </Card>
//         </Grid>
//         <Grid item xs={12} sm={6}>
//           <Card>
//             <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
//               <PersonBonding sliceKey={sliceKey} id={params.id} />
//             </CardContent>
//           </Card>
//         </Grid>
//         <Grid item xs={12} sm={4}>
//           <Card>
//             <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
//               <PersonPast sliceKey={sliceKey} id={params.id} />
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>
//       <Typography component="span">
//         <Box textAlign='center' padding={1}>
//           <Button variant="outlined" size='small' onClick={() => {personaPost()}} disabled={!enabledSave}>
//             {(params.id > 0 ? "Guardar" : idNew > 0 && params.idTipoPersona == 23 ? "Registrar a la Madre" : "Guardar")}
//             <IconSave />
//           </Button>
//         </Box>
//       </Typography>
//     </div>
//   )
// }

// export default Edit

import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { initPerson } from "../../redux/person/personSlice";
import { usePersonNaturalForm } from "../../hooks/person/usePersonNaturalForm"
import PersonNaturalFormBody from "../../components/person/PersonNaturalFormBody"
import PageHeader from "../../components/common/PageHeader"
import SaveButtonBar from "../../components/common/SaveButtonBar"

const Edit = (props) => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const sliceKey = "personEdit";

  useEffect(() => {
      dispatch(initPerson({ sliceKey: sliceKey }));
  }, [dispatch, sliceKey]);

  const fetchOpen = useCallback(async () => {
    setIsReadOnly(false)
  }, [props.openClose])

  useEffect(() => {
    fetchOpen();
  }, [])

  const {
    isReadOnly,
    setIsReadOnly,
    idNew,
    savePerson
  } = usePersonNaturalForm(sliceKey, {
      useBonding: true
  });

  return (
    <div>
      <PageHeader
        title={(params.id == 0 ? "Nueva" : "Editar") + " Persona Natural"}
        backTo="/person"
      />
      
      <SaveButtonBar
        onClick={savePerson}
        disabled={isReadOnly}
      />

      <PersonNaturalFormBody
        sliceKey={sliceKey}
        id={params.id}
        hideInputs={false}
        showBonding={true}
        isReadOnly={isReadOnly}
      />

      <SaveButtonBar
        onClick={savePerson}
        disabled={isReadOnly}
      />
    </div>
  )
}

export default Edit

